import { Textarea } from '@src/components/ui/Textarea';
import { ESelectIntents } from '@src/typings';
import { Dropdown } from 'antd';
import { useState } from 'react';
import { PiBracketsCurlyBold } from 'react-icons/pi';
import { Input } from '../Input/Input';
import { Select } from '../Select';
import { IInputWithTags, Option } from './types';

export function InputWithTags({
    error,
    type,
    label,
    placeholder,
    help,
    maxLength,
    required,
    field,
    tagOptions,
    showTags = true,
}: IInputWithTags) {
    const [selected, setSelected] = useState<Option | null>();

    function renderSelectTag() {
        return (
            <Select
                placeholder={placeholder}
                value={selected?.value}
                className="bg-white rounded-xl"
                autoFocus
                showSearch
                intent={ESelectIntents.default}
                options={tagOptions}
                onChange={(value: any) => {
                    field.onChange(
                        field.value ? field.value + ' ' + value : value
                    );
                    setSelected(null);
                }}
                optionRender={(option) => <span>{option.data.label}</span>}
            />
        );
    }

    function renderDropDown(className?: string) {
        return (
            <Dropdown
                className={className}
                trigger={['click']}
                dropdownRender={() => renderSelectTag()}
                destroyPopupOnHide
            >
                <PiBracketsCurlyBold
                    size={18}
                    className="fill-primary cursor-pointer"
                />
            </Dropdown>
        );
    }

    if (type === 'Input') {
        return (
            <Input
                placeholder={placeholder}
                {...field}
                onChange={(e) => {
                    field.onChange(e.target.value);
                }}
                error={error}
                label={label}
                help={help}
                addonAfter={renderDropDown()}
                maxLength={maxLength}
                showCount={maxLength ? true : false}
                required={required}
            />
        );
    }

    return (
        <div className="grid gap-4">
            <div className="relative">
                {showTags &&
                    renderDropDown(
                        label
                            ? 'absolute right-3 top-12 z-10'
                            : 'absolute right-3 top-2 z-10'
                    )}
                <Textarea
                    label={label}
                    required={required}
                    data-component-name={'rcs-text'}
                    placeholder={placeholder}
                    rows={6}
                    {...field}
                    error={error}
                    onChange={(e) => {
                        field.onChange(e.target.value);
                    }}
                    className="pr-6"
                    help={help}
                    maxLength={maxLength}
                    showCount={maxLength ? true : false}
                />
            </div>
        </div>
    );
}
